import React from 'react';
import { List } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils

import queries from '../../../utils/queries'
import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
  return (
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.pais?elemento.pais:''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrEmpresa}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.nit?elemento.nit:''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.codEmpresa}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.comercialAtiende?elemento.comercialAtiende:''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.direccion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.telefono}</td>
      <td className='' style={{color: 'black', background: '##ffffff'}}>
        <a style={{color: 'black'}}
            href={'images/logos/' + elemento.logo}
            target="_blank">
          {elemento.logo}
        </a>
      </td>
      <td className='' style={{color: 'black', background: '##ffffff'}}>
        <a style={{color: 'black'}}
            href={'images/logos/' + elemento.rut}
            target="_blank">
          {elemento.rut}
        </a>
      </td>
      <td className='' style={{color: 'black', background: '##ffffff'}}>
        <a style={{color: 'black'}}
            href={'images/logos/' + elemento.camara}
            target="_blank">
          {elemento.camara}
        </a>
      </td>
    </tr>  
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento}
        handleClickidLista={handleClickidLista}
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class ConfEmpresa2 extends React.Component {  
  state={argsBuscEmpre: {}}

  componentDidUpdate(prevProps){
    if(this.props.argsBuscEmp!==this.state.argsBuscEmpre){
      let argsBuscEmp = ""
      let argsBuscar = ""
      if(this.props.argsBuscEmp.descrEmpresa){
        argsBuscar += `'descrEmpresa': /${this.props.argsBuscEmp.descrEmpresa}/i`
      }
      argsBuscEmp = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {descrEmpresa: 1}}]`}
      this.props.allEmpresaRtes.refetch(argsBuscEmp)  
      this.setState({argsBuscEmpre: this.props.argsBuscEmp})    
    }
  }

  render(){
    let list = []
    const a250101 = this.props.autorizacUA.findIndex( autorizac => autorizac === "250101" );
    if(this.props.allEmpresaRtes.allEmpresaRtes){list = this.props.allEmpresaRtes.allEmpresaRtes}

    return (
      <div>
        <List selection>
          <TitDer list={this.props.list} textBoton1="Empresas" btnNuevo={a250101!==-1?"SI":"NO"} styles={this.props.styles} handleClick={this.props.handleClick} />

          <div>
            <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
              <thead className=''>
                <tr className=''>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>País</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Empresa</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Nit</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Código</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Atendida por</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '20%'}}>Dirección</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Teléfono</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Logo</th>            
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>RUT</th>            
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Cámara Cio</th>            
                </tr>
              </thead>
              <Lista list={list} handleClickidLista={this.props.handleClickidLista}/>
            </table>
            <p></p>
          </div>
        </List>
      </div>
    )
  }
};

export default compose(
  // graphql(queries.query.allEmpresaRtes, {name:'allEmpresaRtes',
  //   options: (props) => {return {variables: {tipoqry: `[]`}}}})
  graphql(queries.query.allEmpresaRtes, {name:'allEmpresaRtes',
    options: (props) => {return {variables: {tipoqry: `[{$sort: {descrEmpresa: 1}}]`}}}}),


)(ConfEmpresa2) 
